import { isAxiosError } from 'axios';

/** Texto local da falha; o interceptor continua responsável pelo aviso global. */
export function mensagemErroAtendimento(erro: unknown, alternativa: string): string {
  if (!isAxiosError(erro)) return alternativa;
  const dados = erro.response?.data;
  const mensagem = typeof dados?.mensagem === 'string' ? dados.mensagem : undefined;
  if (mensagem) return mensagem;
  if (Array.isArray(dados?.erros)) return dados.erros.join(' ');
  if (erro.response?.status === 403)
    return 'Não foi possível confirmar o acesso a esta escola ou funcionalidade. Atualize a sessão e tente novamente.';
  if (erro.response?.status === 401) return 'Sua sessão precisa ser renovada para continuar.';
  return alternativa;
}
